import React from "react";
import SVG from "react-inlinesvg";
import Modal from "react-modal";
import { focusElement } from "tsi-common-react/src/utils/keyboardFocus";
import { t } from "ttag";

import iconXClose from "../../svg/x-close.svg";

interface IOwnProps {
    mapSmallSrc: string;
    mapLargeSrc: string;
    mapImageAlt: string;
}

type IProps = IOwnProps;

export const FlagshipMapModal = (props: IProps): React.ReactNode => {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    const onOpenModal = (event: React.MouseEvent<HTMLElement>) => {
        if (event) {
            event.preventDefault();
        }
        setModalIsOpen(true);
    };

    const onCloseModal = (event: React.MouseEvent<HTMLElement>) => {
        if (event) {
            event.preventDefault();
        }
        setModalIsOpen(false);
    };

    return (
        <div className="modal">
            <button
                type="button"
                className="modal-trigger"
                id="modal-trigger"
                onClick={onOpenModal}
            >
                <img alt={props.mapImageAlt} src={props.mapSmallSrc} />
            </button>
            <Modal
                aria={{
                    modal: true,
                }}
                contentLabel={t`Flagship store information`}
                className="modal-inner"
                isOpen={modalIsOpen}
                onAfterOpen={() => {
                    focusElement(".modal-close button--ghost");
                }}
                onRequestClose={onCloseModal}
                role="dialog"
            >
                <button
                    aria-label={t`Close`}
                    className="modal-close button--ghost"
                    onClick={onCloseModal}
                >
                    <SVG
                        aria-hidden="true"
                        className="modal-close__icon"
                        src={iconXClose}
                        title={t`Close Icon`}
                    />
                </button>
                <img alt={props.mapImageAlt} src={props.mapLargeSrc} />
            </Modal>
        </div>
    );
};
